import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/summer.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';
const TITLE = "كم باقي على الصيف 2026 - العد التنازلي لبداية فصل الصيف";
const DESCRIPTION = "كم باقي على الصيف 2026، متى يبدأ الصيف 2026، تاريخ بداية الصيف 2026، متى ينتهي الصيف 2026، العد التنازلي لفصل الصيف، موعد الصيف 2026، كم يوم باقي على الصيف، متى يبدأ فصل الصيف في السعودية، تاريخ بداية الصيف 1446 هجري، متى ينتهي فصل الصيف 2026، كم باقي على الصيف 1446، موعد بداية الصيف في الدول العربية";
const KEYWORDS = "كم باقي على الصيف 2026، متى يبدأ الصيف 2026، تاريخ بداية الصيف 2026، متى ينتهي الصيف 2026، العد التنازلي لفصل الصيف، موعد الصيف 2026، كم يوم باقي على الصيف، متى يبدأ فصل الصيف في السعودية، تاريخ بداية الصيف 1446 هجري، متى ينتهي فصل الصيف 2026، كم باقي على الصيف 1446، موعد بداية الصيف في الدول العربية";
const OG_URL = "https://do-calculate.com/articles-ar/summer/";
function SummerCountdown() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const summerStartDate = new Date("2026-06-20T00:00:00");
    const summerEndDate = new Date("2026-09-22T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(summerStartDate));
    const [isSummerStarted, setIsSummerStarted] = useState(new Date() >= summerStartDate);
    const [isSummerEnded, setIsSummerEnded] = useState(new Date() >= summerEndDate);
    useEffect(() => {
        const timer = setTimeout(() => {
            const now = new Date();
            setIsSummerStarted(now >= summerStartDate);
            setIsSummerEnded(now >= summerEndDate);
            if (!isSummerStarted) {
                setTimeLeft(calculateTimeLeft(summerStartDate));
            } else if (!isSummerEnded) {
                setTimeLeft(calculateTimeLeft(summerEndDate));
            }
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft, isSummerStarted, isSummerEnded]);
    const summerDates = [
        { name: 'فصل الصيف 2026', start: new Date("2026-06-20T00:00:00"), end: new Date("2026-09-22T00:00:00") },
        { name: 'فصل الصيف 2026', start: new Date("2026-06-21T00:00:00"), end: new Date("2026-09-23T00:00:00") },
        { name: 'فصل الصيف 2027', start: new Date("2027-06-21T00:00:00"), end: new Date("2027-09-23T00:00:00") },
        { name: 'فصل الصيف 2028', start: new Date("2028-06-20T00:00:00"), end: new Date("2028-09-22T00:00:00") },
        { name: 'فصل الصيف 2029', start: new Date("2029-06-20T00:00:00"), end: new Date("2029-09-22T00:00:00") },
    ];
    return (
        <div className="rtl">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>
                كم باقي على الصيف 2026
            </h1>
            <div>
                <BlinkingText text={`كم باقي على ${isSummerStarted ? 'انتهاء' : 'بداية'} فصل الصيف 2026: ${isSummerStarted ?
                    'يبدأ فصل الصيف 2026 يوم الجمعة بتاريخ 20/06/2026 ميلادي وينتهي يوم الإثنين بتاريخ 22/09/2026 ميلادي' :
                    'من المتوقع أن يبدأ فصل الصيف 2026 يوم الجمعة بتاريخ 20/06/2026 ميلادي وينتهي يوم الإثنين بتاريخ 22/09/2026 ميلادي'}`} />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                                        <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th >يوم</th>
                                <th >ساعة</th>
                                <th >دقيقة</th>
                                <th >ثوانٍ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="days">{timeLeft.days}</td>
                                <td id="hours">{timeLeft.hours}</td>
                                <td id="minutes">{timeLeft.minutes}</td>
                                <td id="seconds">{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ textAlign: 'center', fontSize: '24px', marginTop: '10px' }}>
                        {isSummerStarted ?
                            (isSummerEnded ? 'فصل الصيف انتهى لهذا العام' : 'فصل الصيف بدأ!') :
                            'حتى بداية فصل الصيف'}
                    </div>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>مواعيد فصل الصيف القادمة</h2>
                        <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>فصل الصيف</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>يبدأ</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>ينتهي</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>باقي</th>
                                </tr>
                            </thead>
                            <tbody>
                                {summerDates.map((date, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{date.name}</td>
                                        <td style={{ padding: '12px' }}>{date.start.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{date.end.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{calculateTimeLeft(date.start).days} يوم</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>كم باقي على الصيف</h3>
                    <p>
                        في هذا المقال، نقدم لكم العد التنازلي المفصل لفصل الصيف، لتكونوا على اطلاع دائم بكم يوم باقٍ على بداية أو نهاية هذا الفصل. الكثير منا يتسائلون كم باقي على الصيف، لهذا نقدم لكم في هذا المقال العد التنازلي للصيف لتتمكنوا من معرفة كم باقي على بداية الصيف أو نهايته.
                    </p>
                    <p>
                        يبدأ فصل الصيف لعام 2026/1446 هجري بتاريخ 20/06/2026 ميلادي يوم الجمعة، وينتهي بتاريخ 22/09/2026 ميلادي يوم الإثنين. يمكنكم مشاهدة العد التنازلي لفصل الصيف في هذا المقال.
                    </p>
                    <p>
                        تجدون هنا العد التنازلي للصيف حيث يمكنكم معرفة كم باقي يوم على بداية أو نهاية فصل الصيف.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        احسب كم باقي على الصيف
                    </h3>
                    <p>
                        من خلال برنامج حساب العد التنازلي للصيف يمكنكم معرفة كم باقي على بداية أو نهاية فصل الصيف بالتقويم الميلادي والهجري، كما يمكنكم معرفة باقي على الصيف كم يوم، وكم تبقى للصيف، كم تبقى للصيف بالأيام، ومتى الصيف العد التنازلي، باقي على الصيف، كم تبقى على الصيف، كم باقي عن الصيف، باقي كم يوم على الصيف، كم باقي عن الصيف، كم تبقى للصيف، كم متبقي على الصيف، كم يوم باقي للصيف، كم يوم على الصيف، كم بقي على الصيف، كم باقي على الصيف، باقي كام يوم على الصيف، وموعد الصيف لهذه السنة.
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        فصل الصيف
                    </h3>
                    <p>
                        فصل الصيف هو أحد الفصول الأربعة في السنة، ويتميز بارتفاع درجات الحرارة وطول النهار وقصر الليل. يبدأ الصيف في النصف الشمالي من الكرة الأرضية في 20 أو 21 يونيو وينتهي في 22 أو 23 سبتمبر من كل عام. يعتبر الصيف وقتًا للعطلات والاستجمام والسفر إلى المناطق الساحلية والباردة للهروب من حرارة الجو.
                    </p>
                    <div>
                        <br />
                        <img
                            src={imageUrl}
                            alt="كم باقي على الصيف 2026"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default SummerCountdown;